import { useEffect, useState } from 'react';
import {
  usePasswordResetMutation,
  usePasswordResetQuestion,
} from '@tcs/client-portal-common/hooks/auth';
import {
  errors,
  ResetPasswordSteps,
} from '@tcs/client-portal/pages/ResetPassword';

export const usePasswordResetFlow = () => {
  const [activeStep, setActiveStep] = useState(
    ResetPasswordSteps.Identification
  );

  const [identity, setIdentity] = useState<
    { identityId: ''; email: '' } | undefined
  >();

  const [error, setError] = useState<string | undefined>();

  const {
    data: question,
    error: questionError,
    loading,
  } = usePasswordResetQuestion(identity);

  const resetPasswordMutation = usePasswordResetMutation({
    onSuccess: () => {
      setActiveStep(ResetPasswordSteps.PasswordResetComplete);
    },
    onError: () => {
      setError(errors.RESETPASSWORD);
    },
  });

  useEffect(() => {
    if (question?.text) {
      setError(undefined);
      setActiveStep(ResetPasswordSteps.SecurityQuestions);
    }
    if (question && question?.text == null) {
      clearError();
      setActiveStep(ResetPasswordSteps.SecurityQuestionIsEmpty);
    }
  }, [question]);

  useEffect(() => {
    if (questionError) {
      setError(errors.GETQUESTION);
    }
  }, [questionError]);

  const resetPassword = (value: { answer: string }) => {
    if (identity?.identityId) {
      const { answer } = value;
      resetPasswordMutation.mutate({
        identityId: identity?.identityId,
        answer,
      });
    }
  };

  const clearError = () => setError(undefined);

  return {
    question: question?.text,
    error,
    loading,
    activeStep,
    setActiveStep,
    setIdentity,
    resetPassword,
    clearError,
  };
};

export default usePasswordResetFlow;
